import { SmartMTEditorPopup, updateSaveButtons } from "./_editor_popup";
import { getBlobUrl, getImgBlob, setImgBlob, setCurrentMode, getCurrentMimeType } from "./_utils";
import { showToastMessage } from "./_utils";


var $ = jQuery;

export const Effects = (attachment) => {
    $('#smart-mt-effects').on('click', function () {
        setCurrentMode('effects');
        let imgBlob = getImgBlob();
        let url = getBlobUrl(imgBlob) !== false ? getBlobUrl(imgBlob) : attachment.url;
        let effectsContent = `
            <div class="smart-mt-content smart-mt-content-effects">
                  <img id="smartmt-edit-image" src="${url}" alt="${attachment.name}" />
            </div>`;

        let effectsSidebar = `
         <div id="effect-controls" class="sidebareffects">
                <div class="smart-mt-effect smart-mt-effect-rotate"><div id="unsaved-changes-message" class="unsaved-changes-message" style="visibility:      hidden;">
                    You have unapplied changes, please Apply your changes below.
                </div>
                <div class="effect-box" id="brightness-box">
                    <label for="brightness">Brightness</label>
                    <input type="range" id="brightness" min="0" max="200" value="100">
                </div>
                <div class="effect-row">
                    <div class="effect-container">
                        <button id="effect-cold" class="image-button"></button>
                        <div class="effect-text">
                            <span class="icon-minus icon-cold">-</span>
                            <p>Cold</p>
                            <span class="icon-plus icon-cold">+</span>
                        </div>
                    </div>
                    <div class="effect-container">
                        <button id="effect-warm" class="image-button"></button>
                        <div class="effect-text">
                            <span class="icon-minus icon-warm">-</span>
                            <p>Warm</p>
                            <span class="icon-plus icon-warm">+</span>
                        </div>
                    </div>
                </div>
        
                <div class="effect-row">
                    <div class="effect-container">
                        <button id="effect-bw" class="image-button"></button>
                        <div class="effect-text">
                            <span class="icon-minus icon-bw">-</span>
                            <p>Gray</p>
                            <span class="icon-plus icon-bw">+</span>
                        </div>
                    </div>
                    <div class="effect-container">
                        <button id="effect-painting" class="image-button"></button>
                        <div class="effect-text">
                            <span class="icon-minus icon-painting">-</span>
                            <p>Golden</p>
                            <span class="icon-plus icon-painting">+</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="button-access">
                <button class="button" id="effect-apply">
                    <span class="dashicons dashicons-saved"></span> Apply
                </button>
            </div>`;

        SmartMTEditorPopup(effectsContent, effectsSidebar);
        initializeEffectsFunctionality(attachment);
    });
};

function initializeEffectsFunctionality(attachment) {
    const imageElement = document.getElementById('smartmt-edit-image');
    const originalImageData = imageElement.src;
    let effectIntensity = { cold: 0, warm: 0, bw: 0, painting: 0 };
    let hasUnsavedChanges = false;

    function applyBrightness() {
        const brightnessValue = document.getElementById('brightness').value;
        const brightness = brightnessValue / 100;
        imageElement.style.filter = `brightness(${brightness}) ${getCurrentFilters()}`;
        setUnsavedChanges(true);
    }

    function getCurrentFilters() {
        let filters = [];
        if (effectIntensity.cold > 0) {
            filters.push(`contrast(${0.8 - 0.05 * effectIntensity.cold}) saturate(${0.6 + 0.05 * effectIntensity.cold}) hue-rotate(-30deg)`);
        }
        if (effectIntensity.warm > 0) {
            filters.push(`contrast(${1.1 + 0.1 * effectIntensity.warm}) saturate(${1.2 + 0.1 * effectIntensity.warm})`);
        }
        if (effectIntensity.bw > 0) {
            filters.push(`grayscale(${effectIntensity.bw * 0.2})`);
        }
        if (effectIntensity.painting > 0) {
            filters.push(`saturate(${1.2 + 0.1 * effectIntensity.painting}) hue-rotate(${30 * effectIntensity.painting}deg) brightness(${1.1 + 0.05 * effectIntensity.painting})`);
        }
        return filters.join(' ');
    }

    function updateFilters() {
        applyBrightness();
    }

    function applyEffects() {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = imageElement.naturalWidth;
        canvas.height = imageElement.naturalHeight;
        ctx.filter = imageElement.style.filter;
        ctx.drawImage(imageElement, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
            if (blob) {
                const newImageURL = getBlobUrl(blob);
                setImgBlob(blob);
                imageElement.src = newImageURL;
                imageElement.style.filter = '';
                removeUnsavedChangesMessage();

                showToastMessage("Successfully Applied", "success");
            } else {
                console.error('Failed to create a blob for the effects.');
                showToastMessage("Failed to apply effects.", "error");
            }
        }, getCurrentMimeType());
    }

    function setUnsavedChanges(hasChanges) {
        hasUnsavedChanges = hasChanges;
        const messageElement = document.getElementById('unsaved-changes-message');
        if (messageElement) {
            messageElement.style.visibility = hasChanges ? 'visible' : 'hidden';
        }
    }

    function removeUnsavedChangesMessage() {
        setUnsavedChanges(false);
    }
    function resetEffectIntensity() {
        effectIntensity = { cold: 0, warm: 0, bw: 0, painting: 0 };
    }

    const brightnessSlider = document.getElementById('brightness');
    brightnessSlider.addEventListener('input', applyBrightness);

    $(".icon-plus").click(function () {
        const effect = $(this).attr('class').split(' ')[1].split('-')[1];
        if (effectIntensity[effect] < 30) {
            effectIntensity[effect]++;
            updateFilters();
            setUnsavedChanges(true);
        }
    });

    $(".icon-minus").click(function () {
        const effect = $(this).attr('class').split(' ')[1].split('-')[1];
        if (effectIntensity[effect] > 0) {
            effectIntensity[effect]--;
            updateFilters();
            setUnsavedChanges(true);
        }
    });

    $("#effect-apply").click(() => {
        applyEffects();
        resetEffectIntensity();
    });
}
